import { AccordionSummary, accordionSummaryClasses } from '@mui/material';
import { shouldNotForwardProps } from '@/core/helpers';
import { styled } from '@/core/ui';
export const GroupedListItemAccordionSummary = styled(AccordionSummary, 
// shouldNotForwardProps<GroupedListItemAccordionSummaryProps>('isCurrentlySticky', 'withScrollToStartIcon')
shouldNotForwardProps('isCurrentlySticky'))(({ theme, isCurrentlySticky }) => ({
    // All styles should be the same as in `StickyTableHead` component.
    position: 'sticky',
    top: -6,
    boxShadow: isCurrentlySticky ? theme.shadows[3] : undefined,
    /**
     * Prevents row first cell checkbox to be visible through table header.
     * `-50` doesn't allow header overflow sidebar menu which zIndex is `theme.zIndex.mobileStepper` (1000).
     */
    zIndex: theme.zIndex.mobileStepper - 50,
    [`&`]: [
        {
            backgroundColor: isCurrentlySticky ? theme.palette.background.default : theme.palette.common.white,
        },
        theme.applyStyles('dark', {
            background: isCurrentlySticky ? theme.palette.zinc[950] : theme.palette.background.light,
        }),
    ],
    letterSpacing: '-0.35px',
    fontFamily: theme.typography.body1.fontFamily,
    padding: 0,
    [`.${accordionSummaryClasses.content}`]: {
        margin: 0,
        padding: theme.spacing(2, 6),
        [`&.${accordionSummaryClasses.expanded}`]: {
            margin: 0,
        },
    },
}));
